// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.risk-maintenance-id-cell[data-v-5b9d8c55] {
  display: flex;
  align-items: center;
  gap: 6px;
}
.risk-maintenance-id-cell .risk-maintenance-id-cell__link[data-v-5b9d8c55] {
  position: relative;
  z-index: 1;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
}
.risk-maintenance-id-cell .risk-maintenance-id-cell__link[data-v-5b9d8c55]:hover {
  color: #0056b3;
}
.risk-maintenance-id-cell.risk-maintenance-id-cell__warning-label .risk-maintenance-id-cell__link[data-v-5b9d8c55] {
  color: #fd7e14;
}
.risk-maintenance-id-cell.risk-maintenance-id-cell__warning-label .risk-maintenance-id-cell__link[data-v-5b9d8c55]:hover {
  color: #dc6502;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
